import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import DoctorWorkin1 from "../../assets/image/doctorWorking1.png";
import DoctorWorkin2 from "../../assets/image/doctorWorking2.png";
import DoctorWorkin3 from "../../assets/image/doctorWorking3.png";
import DoctorWorkin4 from "../../assets/image/doctorWorking4.png";
import DoctorWorkin5 from "../../assets/image/doctorWorking5.png";

export default function CardSliderLogin() {
  const image = [
    DoctorWorkin1,
    DoctorWorkin2,
    DoctorWorkin3,
    DoctorWorkin4,
    DoctorWorkin5,
  ];
  const text =[
    {title:'گوش دادن فعالانه',text:"  پزشکان باید به دقت به مشکلات و نیازهای بیماران گوش کنند تا بتوانند برای درمان مناسب ترکیبی از راهنمایی و مشورت ارائه دهند."},
    {title:'ارتباط مفهومی ',text:"بیان توضیحات پزشکی به زبان ساده و قابل فهم برای بیماران کمک می‌کند تا بتوانند تصمیمات بهتری درباره درمان‌ها و گزینه‌های درمانی خود بگیرند."},
    {title:'همدلی و تفهیم',text:"نشان دادن تفهیم و همدلی به بیماران باعث افزایش اعتماد و اطمینان به پزشکان می‌شود و همچنین تاثیر مثبتی بر فرآیند بهبود دارد."},
    {title:'احترام به حریم شخصی',text:" پزشکان باید احترام و حریم شخصی بیماران را در هنگام بررسی‌ها و مشاوره‌ها رعایت کنند تا ارتباط مثبتی ایجاد شود. "},
    {title:'ارتقاء اطلاعات بیمار',text:"اطلاع‌رسانی صحیح و جامع به بیماران در مورد وضعیت‌شان، گزینه‌های درمانی و پیش‌بینی‌ها، ارتباط اثربخشی بیشتری بین پزشک و بیمار ایجاد می‌کند."},
  ]
  const [countImage, setCountImage] = useState(0);
  useEffect(() => {
    setTimeout(() => {
      if (countImage <= 3) {
        setCountImage(countImage + 1);
      } else {
        setCountImage(0);
      }
    }, 7000);
  });
  return (
    <Box display='grid' justifyItems='center' px='40px' height='100%' pt='50px' >
        <Box>

      <img style={{width: '100%', height:"auto"}} src={image[countImage]} />
        </Box>
      <Box textAlign={"right"} width='100%'  bottom='0px' >

      <Typography sx={{
          color: "#FFF",
          textAlign: "right",
          fontFamily: "Shabnam",
          fontSize: "25px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "normal",
        }} >{text[countImage].title}</Typography>
      <Typography
        sx={{
            color: "#FFF",
            textAlign: "right",
            fontFamily: "Shabnam",
            fontSize: "25px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal",
            width: "100%",
            height: "auto"
        }}
        >
        {text[countImage].text}
      </Typography>
        </Box>
    </Box>
  );
}
